<p>lifo-table works!</p>
